const logout =
  ({ navigate }) =>
  (dispatch) => {
    dispatch({ type: 'logout' });
    localStorage.removeItem('edu_wa_session_token');
    navigate('/login');
  };

export default logout;
